<div class="sn-drawer__header__primary">
  <ng-content select="[snDrawerNavButton]"></ng-content>
  <h3 *ngIf="title" snDrawerTitle [id]="titleId">{{ title }}</h3>
  <sn-drawer-header-actions
    *ngIf="actions"
    [actions]="actions"
    [context]="context"
  ></sn-drawer-header-actions>
  <ng-content select="sn-drawer-header-actions"></ng-content>
</div>
<ng-content></ng-content>
